import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyStoreTiresEnabled } from 'domains/appContext/AppContext.store';
import { getIsSessionActive } from 'domains/delegation';
import { isDelegationSessionStatusLoading } from 'domains/delegation/DelegationSession.store';
import {
  getBundlesRequestSaga,
  getBundlesSections,
  getMyStoreTires,
  getReferencesRequestSaga,
  getReferencesSections,
  subscribeTiresRequestSaga,
} from 'domains/myStore/MyStore.store';
import { getUserRights, UserRole } from 'domains/user';
import { getData, hasUserAnyRight } from 'utils';

export const useFetchMyStoreBundles = (): void => {
  const dispatch = useDispatch();
  const bundles = useSelector(getBundlesSections);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);
  useEffect(() => {
    if (isDelegationLoading) {
      return;
    }
    if (!bundles.sections.searchStatus) {
      dispatch(getBundlesRequestSaga());
    }
  }, [bundles, dispatch, isDelegationLoading]);
};

export const useFetchMyStoreTires = (): void => {
  const dispatch = useDispatch();
  const myStoreTires = useSelector(getMyStoreTires);
  const userRights = useSelector(getUserRights);
  const myStoreTiresEnabled = useSelector(getMyStoreTiresEnabled);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);

  useEffect(() => {
    if (isDelegationLoading) {
      return;
    }
    const isAuthorized = hasUserAnyRight([UserRole.R2, UserRole.R3, UserRole.R3_MOTRIO], getData(userRights));

    if (myStoreTiresEnabled && isAuthorized && !myStoreTires.brands.searchStatus) {
      dispatch(subscribeTiresRequestSaga());
    }
  }, [dispatch, isDelegationLoading, myStoreTiresEnabled, myStoreTires, userRights]);
};

export const useFetchMyStoreTiresAsDelegatedClient = (): void => {
  const isDelegationSessionActive = useSelector(getIsSessionActive);
  const dispatch = useDispatch();
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);
  useEffect(() => {
    if (isDelegationLoading) {
      return;
    }
    if (isDelegationSessionActive) {
      dispatch(subscribeTiresRequestSaga());
    }
  }, [dispatch, isDelegationSessionActive, isDelegationLoading]);
};

export const useFetchMyStoreReferences = (): void => {
  const dispatch = useDispatch();
  const references = useSelector(getReferencesSections);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);
  useEffect(() => {
    if (isDelegationLoading) {
      return;
    }
    if (!references.sections.searchStatus) {
      dispatch(getReferencesRequestSaga());
    }
  }, [references, dispatch, isDelegationLoading]);
};
